<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>


export default {
    name: 'app',
    computed: {
        getUserInfo(){
            return this.$store.getters.getUserInfo;
        },
    },
    mounted() {

        //刷新前存储用户信息
        window.addEventListener('pagehide',e=>{
            var userInfo = this.$store.getters.getUserInfo;
            sessionStorage.setItem('userInfo',JSON.stringify(userInfo));
        });
        

    }
}
</script>

<style lang="less">
#app {height: 100%;
    .a{color: @theme;}

}
</style>
